import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.18218 1.06066L2.12152 0L0.000200272 2.12132L1.06086 3.18198L4.60314 6.72427L1.06086 10.2666L0.000200272 11.3272L2.12152 13.4485L3.18218 12.3879L6.72447 8.84559L10.2668 12.3879L11.3274 13.4485L13.4487 11.3272L12.3881 10.2666L8.84579 6.72427L12.3881 3.18198L13.4487 2.12132L11.3274 0L10.2667 1.06066L6.72446 4.60295L3.18218 1.06066Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
